<template>
    <div class="panel">
        <div class="panel__header">
            <h2>
                <i class="panel__header__icon icons icon-chart"></i>
                <span>{{$t('dashboard.invoices.title')}}</span>
            </h2>
            <div @click.prevent="addNew" class="panel_header__action">
                <i class="panel_header__action__icon icons icon-plus"></i>
                <a class="button--link hidden-xs">{{$t('dashboard.invoices.add_new')}}</a>
            </div>
        </div>
        <div class="panel__body">
            <invoices-table />
        </div>
        <invoice-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import InvoicesTable from '@/components/tables/dashboard/InvoicesTable';
    import InvoiceModal from '@/components/modals/dashboard/InvoiceModal';

    import Invoice from '@/models/Invoice';

    @Component({
        components: {
            InvoicesTable,
            InvoiceModal,
        }
    })
    export default class InvoicesPanel extends Vue {
        name = 'invoices-panel';

        addNew() {
            const url = `/trajectories/${this.$store.state.trajectory.trajectory.id}/invoices`;
            const invoice = new (Invoice.makeModel(url));
            this.$modal.show('invoice-modal', { invoice });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/InvoicesPanel.vue